import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';

export default function helixAnalyzerMaxConnectionReachedReducer(
	state = initialState.helixAnalyzerMaxConnectionReached,
	action
) {
	switch (action.type) {
		case types.POST_HELIX_ANALYZER_MAX_CONNECTION_REACHED: {
			if (
				action.response &&
				action.responseObj.status === HttpStatusCodes.Ok &&
				Array.isArray(action.response) &&
				action.response.length > 0 &&
				action.response[0].hasOwnProperty('maxConnectionReached')
			) {
				return action.response[0].maxConnectionReached;
			} else {
				return state;
			}
		}
		case types.CLEAR_HELIX_ANALYZER_MAX_CONNECTION_REACHED: {
			return null;
		}
		default:
			return state;
	}
}
